import React, { useEffect, useState } from 'react';
import './login.css';
import axios from "axios";
import BaseUrl from '../../base-api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setUser } from '../redux/reducer/AdminReducer';
import { useDispatch } from 'react-redux';
const Login = () => {
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [error, setError] = useState('');
  const [timer, setTimer] = useState(0);
  const navigate = useNavigate();
const dispatch=useDispatch()
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleMobile = (e) => {
    const value = e.target.value;
    let number = value.replace(/\D/g, '');
    if (number.length > 10) {
      number = number.slice(0, 10);
    }
    setError('');

    setMobile(number)
  };

  const sendOtp = async () => {
    setOtp(new Array(6).fill(""));
    let number = mobile;
    if (!/^\d+$/.test(number)) {
      toast.error("Center Code can't be empty and must be number.");

    } else {
      setError('');

      setIsSendingOtp(true);
      try {
        const formData = new FormData();
        formData.append("mobileNumber", mobile)
        const res = await axios.post(`${BaseUrl}/api/auth/authenticateUser`, formData, {
          headers: {
            'Content-Type': "application/json"
          },


        });
        if (res) {
          toast.success(res.data.message);
          setIsOtpSent(true);
          setTimer(120);
        }
        else {
          toast.error(res.data?.message);
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
      }
      finally {
        setIsSendingOtp(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {


      if (!otp || otp.some((digit) => digit === "") || otp.length !== 6) {
        toast.error("Please enter a valid 6-digit OTP!");
        return;
      }

      const otpValue = otp.join("");
      const formData = new FormData();
      formData.append("mobileNumber", mobile)
      formData.append("onetimepassword", otpValue)
      const res = await axios.post(`${BaseUrl}/api/auth/authorizeUser`, formData, {
        headers: {
          'Content-Type': "application/json"
        },

      });
      if (res) {
        dispatch(setUser(res.data?.role));
if(res.data?.role ==="ADMIN"){
    navigate("/dashboard/home-admin");
}else{
     navigate("/dashboard/home");
}
 sessionStorage.setItem("userToken", res.data.token)
        res.data.expireDate = new Date(
          new Date().getTime() + res.data.expiresIn * 1000,
        );
        sessionStorage.setItem("userDetails", JSON.stringify(res.data))
      }
      else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
    finally {
      // dispatch(setLoading(false));
    }
  }
  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };
  const handleOtpClick = (index) => {
    if (otp.every((digit) => digit === "")) {
      document.getElementById("otp-0").focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  return (
    <>
      <div className='loginDiv'>
        <div className="login-container" style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '8px' }}>
          <h2 style={{ color: 'white' }}>Sign In to your Account</h2>
          <form onSubmit={handleSubmit}>

            {error && (
              <div className="error" style={{ color: 'red', marginBottom: '10px' }}>
                {error}
              </div>
            )}

            <div className="position-relative">
              <span className="position-absolute top-50 translate-middle-y ms-3">
                <i
                  className="bi bi-telephone-fill"
                  style={{ color: "grey" }}
                ></i>
              </span>
              <input
                className="form-control ps-5"
                type="text"
                placeholder="Enter Center Code"
                value={mobile}
                onChange={handleMobile}
                required
                disabled={isOtpSent}
              />
            </div>

            {isOtpSent && (
              
              <div className="mt-3 position-relative">
                <div className="d-flex justify-content-between mt-3">
                  {[...Array(6)].map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      id={`otp-${index}`}
                      maxLength="1"
                      className="form-control text-center "
                      style={{
                        width: "40px",
                        height: "40px",
                        fontSize: "18px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                      }}
                      value={otp[index] || ""}
                      onChange={(e) => handleOtpChange(e, index)}
                      onClick={() => handleOtpClick(index)}
                      onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    />
                  ))}
                </div>
              </div>
            )}

            {!isOtpSent && (
              <button className='mt-3 w-100' type="button" onClick={sendOtp} disabled={isSendingOtp}>{isSendingOtp ? "Sending..." : "Send OTP"}</button>
            )}

            {isOtpSent && (
              <>
                <div className='d-flex'>
                  <button className='me-2 mt-3 w-50' type="submit">Login</button>
                  <button className='btn btn-danger mt-3 w-50' type="button" onClick={sendOtp} disabled={timer > 0}>
                    {timer > 0 ? `Resend (${timer}s)` : "Resend OTP"}
                  </button>
                </div>
              </>
            )}
          </form>
        </div>

      </div>

    </>
  );
};

export default Login;
